import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';

import { DeclarationCustomsFlowType } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  lrn: string;
  flow?: DeclarationCustomsFlowType;
}
export const useSendOneHv = () => {
  const queryClient = useQueryClient();

  const mutationFn = async ({ lrn, flow }: HookProps) => {
    const result = await apiClient.idms.sendOneDeclaration.mutation({ body: { LRN: lrn, flow } });
    if (result.status !== 200) {
      throw result.body;
    }
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declarations'] });
      queryClient.invalidateQueries({ queryKey: ['declaration-groups'] });
      queryClient.invalidateQueries({ queryKey: ['declaration-list'] });
      toast.success('Declaration sent successfully!');
    },
    onError: (error) => {
      const errorResponse = (error as AxiosError)?.response?.data;
      const errorMessage = errorResponse?.retryAfter
        ? `Error sending declaration! ${errorResponse?.error || ''} ${errorResponse?.message || ''}`
        : `Error sending declaration!`;
      showErrorToast(error, errorMessage);
    },
  });
};
